import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';


export const useCreateCardOrder = () => {
    return useMutation(async (data: any) => {
        const jsonResponse = await request({
            data,
            method: 'POST',
            endpoint: 'certificates/create-card-order',
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }

        return jsonResponse;
    });
};

